import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LabelTypeEnum, LabelModeEnum } from './label-type.enum';

@Component({
    selector: 'p-status-main-label',
    template: `
        <div class="p-label-main p-headline-6" [ngClass]="'p-label-main-' + type + ' ' + mode" [class.trigger]="isTriggerMenu">
            {{ label }}
            <p-icon *ngIf="isTriggerMenu" class="p-label-main-icon" name="chevron-down" size="sm"></p-icon>
        </div>
    `,
    styleUrls: ['./p-status-main-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PStatusMainLabelComponent implements OnInit {
    @Input() label?: string;
    @Input() type?: LabelTypeEnum | string;
    @Input() isTriggerMenu = false;
    @Input() mode?: LabelModeEnum | string | undefined = LabelModeEnum.DefaultMode;

    constructor() {}

    ngOnInit(): void {}
}
